import axios from 'axios'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    events: []
  },
  mutations: {
    setEvents (state, events) {
      Vue.set(state, 'events', events)
    }
  },
  getters: {
    getEvents (state) {
      return state.events
    },
    getConfig (state, getters, rootState) {
      return rootState.config
    }
  },
  actions: {
    fetchEvents ({
      getters,
      commit
    }) {
      if (!getters.getConfig.loaded) {
        return []
      }

      axios.get(process.env.VUE_APP_API_URL + '/logineo/events').then((response) =>
        commit('setEvents', response.data)
      )
    }
  }
}
